import React from "react";
import { Typography, Upload } from "antd";
import Button_v2 from "./Button_v2";

const UploadDragger_v2 = (props) => {
  const {
    title = "Drag files here or:",
    helperText = "Supports bulk attachment upload.",
    showActions,
    handleChange,
    isMultiple = false,
  } = props;
  return (
    <Upload.Dragger
      className="upload-dragger"
      multiple={isMultiple}
      beforeUpload={(file) => handleChange({ file }, { pic_title: "OTHER ATTACHMENT", pic_code: "OTHER ATTACHMENT" })}
      showUploadList={false}
      style={{ marginTop: "24px" }}
    >
      <h3 style={{ padding: "8px" }}>{title}</h3>
      <Typography.Paragraph>{helperText}</Typography.Paragraph>
      {showActions && (
        <Button_v2
          type="secondary"
          size="small"
          className="choose-file-btn"
          text="Choose File"
        />
      )}
    </Upload.Dragger>
  );
};

export default UploadDragger_v2;
